import { useEffect, useState } from 'react';
import { PricesAndChartsService } from '@/services/PricesAndChartsService';
import { NotificationType } from '@/types/Common';
import { notify } from '@/utils/notify';

interface PricingContractsState {
  contractsStructure: Record<string, any> | null;
  loading: boolean;
  error: string | null;
}

const useFetchPricingContracts = (): PricingContractsState => {
  const [contractsStructure, setContractsStructure] = useState<Record<string, any> | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const structure = await PricesAndChartsService.fetchContractsStructure();
        setContractsStructure(structure);
      } catch (err: any) {
        const errorMessage = err?.message || 'Unknown error';
        console.error('Error fetching contracts structure:', errorMessage);
        setError(errorMessage);
        notify(
          NotificationType.ERROR,
          `Nie udało się załadować struktury kontraktów. Szczegóły: ${errorMessage}`
        );
      } finally {
        setLoading(false);
      }
    };

    fetchContracts();
  }, []);

  return { contractsStructure, loading, error };
};

export default useFetchPricingContracts;
